// firebase.js（または firebaseInit.js / firebaseClient.js 等、あなたの実ファイル名に合わせて）
// ※あなたが貼ってくれた内容をベースに、tSubDoc を追加した「全文」です。

import { initializeApp, getApps, getApp } from "firebase/app";
import {
  getAuth,
  initializeAuth,
  browserLocalPersistence,
  browserSessionPersistence,
  inMemoryPersistence,
} from "firebase/auth";
import { getFirestore, collection, doc } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { TENANT_ID } from "./tenant";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// StrictMode/HMR 対策：二重初期化防止
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// ⚠Auth の保存先から IndexedDB を外している。
//   getAuth() の既定は indexedDBLocalPersistence を最優先に試すが、LINE アプリ内ブラウザでは
//   IndexedDB の読み書きが「成功も失敗もしない」ことがあり、Auth の初期化が終わらない。
//   その状態だと signInWithCustomToken がいつまでも返らず、画面はローディングのまま
//   （2026-10-01 実機: LINEログインが stage=auth で停止。loginWithLine 自体は 200/1.2秒で成功）。
//   localStorage でも「次に開いたときもログイン済み」は保たれるので、体験は変わらない。
//   ⚠ここを getAuth() に戻すと同じ停止が再発する。
function createAuth() {
  try {
    return initializeAuth(app, {
      persistence: [
        browserLocalPersistence,
        browserSessionPersistence,
        inMemoryPersistence,
      ],
    });
  } catch (e) {
    // 既に初期化済み（HMR / 二重読み込み）の場合はそれを使う
    console.warn("[firebase] initializeAuth fallback:", e?.message || e);
    return getAuth(app);
  }
}

export const auth = createAuth();
export const db = getFirestore(app);

// tenants/{tenantId}/{rootCollection}
export const tCollection = (root, tenantId = TENANT_ID) =>
  collection(db, "tenants", tenantId, root);

// tenants/{tenantId}/{rootCollection}/{docId}
export const tDoc = (root, docId, tenantId = TENANT_ID) =>
  doc(db, "tenants", tenantId, root, docId);

// tenants/{tenantId}/{rootCollection}/{docId}/{subcol}
export const tSubCollection = (root, docId, subcol, tenantId = TENANT_ID) =>
  collection(db, "tenants", tenantId, root, docId, subcol);

// ✅ 追加：tenants/{tenantId}/{rootCollection}/{docId}/{subcol}/{subdocId}
// 例）tenants/suomi/customers/{uid}/entitlements/{entId}
export const tSubDoc = (root, docId, subcol, subdocId, tenantId = TENANT_ID) =>
  doc(db, "tenants", tenantId, root, docId, subcol, subdocId);

// Callable Functions はリージョンを本番と一致させる
export const functions = getFunctions(app, "asia-northeast1");

export default app;